import { render, staticRenderFns } from "./Screen4.vue?vue&type=template&id=7dc1d1d0&scoped=true&lang=html&"
import script from "./Screen4.vue?vue&type=script&lang=js&"
export * from "./Screen4.vue?vue&type=script&lang=js&"
import style0 from "./Screen4.vue?vue&type=style&index=0&id=7dc1d1d0&prod&lang=scss&"
import style1 from "./Screen4.vue?vue&type=style&index=1&id=7dc1d1d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc1d1d0",
  null
  
)

export default component.exports